import React from 'react';
import PropTypes from 'prop-types';

const ShipmentIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '16px';
  const h = (height) ? height.toString().concat('px') : '18px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 24 24"
      width={w}
      height={h}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
                // eslint-disable-next-line max-len
        d="M8.3753 2C8.13456 2 7.90526 2.10563 7.74504 2.29033L3.3674 7.33688C3.1483 7.46152 3 7.70118 3 7.97636V8.0912V21.1319V21.2692C3 21.6728 3.319 22 3.7125 22H20.2875C20.681 22 21 21.6728 21 21.2692V11.7324V8.0912V7.97636C21 7.70117 20.8517 7.46152 20.6326 7.33687L16.255 2.29033C16.0947 2.10563 15.8654 2 15.6247 2H8.3753ZM11.1556 7.22319H5.72876L8.75372 3.73602H11.1556V7.22319ZM12.8444 7.22319V3.73602H15.2463L18.2712 7.22319H12.8444ZM4.69575 20.2608V8.98481H19.3043V20.2608H4.69575Z"
        fill={(fill) || '#FF5F14'}
      />
    </svg>
  );
};

ShipmentIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default ShipmentIcon;
